import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  appBar: {
    marginLeft: 0,
    height: 48,
    padding: 0,
    backgroundColor: theme.palette.background.default,
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    borderStyle: 'solid',
    borderBottomWidth: 1,
    borderBottomColor: '#C4C6C9',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'center',
  },
  header: {
    height: 14,
    zIndex: 9999,
    display: 'flex',
    alignItems: 'center',
  },
  menuIcon: {
    marginLeft: 2,
  },
  logoButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: 0,
    marginLeft: 24,
    backgroundColor: 'transparent',
  },
  logoButtonMobile: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: 0,
    backgroundColor: 'transparent',
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  avatar: {
    width: 60,
    height: 60,
  },
  breadcrumbContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: 16,
  },
  breadcrumbText: {
    fontWeight: 'bold',
    textTransform: 'uppercase',
    textAlign: 'center',
  },
  avatarButton: {
    marginRight: 8,
    '& :hover': {
      opacity: 0.9,
    },
  },
  avatarImage: {
    height: 32,
    width: 32,
    borderRadius: '50%',
    objectFit: 'cover',
    position: 'absolute',
    right: 0,
  },
}));
